import { ObjectCreationValidatorErrorI } from '@/typescript/types/abstracts/errors/ErrorHandlerTypes'

export class ObjectCreationValidatorError extends Error implements ObjectCreationValidatorErrorI {
  type: string
  constructor(error: Error) {
    super(error.message)
    this.type = 'object-creation-validator-error'
    this.name = error.name
  }
}
